import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import { TextStyleKit } from '@tiptap/extension-text-style'
import { Table, TableRow, TableHeader, TableCell } from '@tiptap/extension-table'

/**
 * The TipTap schema of every `rich-text` field of the builder, shared by the
 * in-place bubble (InlineRichTextEditor) and the popover (RichTextEditor): a
 * content formatted in one reads back in the other only if both parse the
 * same nodes and marks. A fresh list per editor — TipTap configures extension
 * instances.
 */
export const richTextExtensions = () => [
  StarterKit.configure({ heading: { levels: [2, 3, 4] } }),
  Link.configure({ openOnClick: false }),
  Underline,
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  // Size and colour: two attributes of the `textStyle` mark. The rest of the
  // kit stays off — font family and line height belong to the block (its DS
  // classes), not to the selected word.
  TextStyleKit.configure({
    fontSize: { types: ['textStyle'] },
    color: { types: ['textStyle'] },
    fontFamily: false,
    lineHeight: false,
    backgroundColor: false,
  }),
  // Tables are kept, not flattened: a rich text holding a <table> — any field
  // of any block, wiki pages first — survives an edit. No resize handles:
  // widths follow the field's `prose` recipe.
  Table.configure({ resizable: false }),
  TableRow,
  TableHeader,
  TableCell,
]
